module.exports = __webpack_public_path__ + "056bfbd8f40f42ab9b27e4cf0203f7b6.svg";